import React, { ChangeEvent, FC } from 'react';
import { Checkbox, FormControlLabel, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { Field } from 'containers/Forms/Customers/views/CreateCustomerBeta/components';
import { getSelectedCustomer } from 'reducers/customerSearch';
import { seniorTagID } from 'plugins/mm/constants';

const getHasSeniorTag = createSelector(getSelectedCustomer, customer =>
  customer.tags?.find(tag => tag.id === seniorTagID),
);

interface Props {
  customer: { senior?: 0 | 1 };
  handleChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

const SeniorField: FC<Props> = ({ customer, handleChange }) => {
  const { t } = useTranslation('createCustomer');
  const customerHasSeniorTag = useSelector(getHasSeniorTag);
  return (
    <Field name="senior" wrapper={Grid} wrapperProps={{ item: true, xs: 12 }}>
      <FormControlLabel
        control={
          <Checkbox
            name="senior"
            checked={!!(customer.senior ?? customerHasSeniorTag ?? 0)}
            onChange={handleChange}
          />
        }
        label={t('fields.senior')}
      />
    </Field>
  );
};

export default SeniorField;
